import DefaultOnboardingProvider from '@psl/flows/onboarding/DefaultOnboardingProvider';
import { createContext, memo, ReactNode, useContext } from 'react';
import { BehaviorSubject } from 'rxjs';
import { OnboardingUserData } from './functions/types';
import { OnboardingProgressInfo } from './functions/useOnboardingProgress';

export type OnboardingContextProps = {
  authenticationRequired: boolean;
  initialUserId: string | undefined;
  hasProfile?: boolean;
  initialProgress: OnboardingProgressInfo | null | undefined;
  userData$: BehaviorSubject<OnboardingUserData>;
  reset: () => void;
};

export const OnboardingContext = createContext<OnboardingContextProps>(
  null as any,
);

export const useOnboardingContext = () => {
  return useContext(OnboardingContext);
};

export const OnboardingContextProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    return <DefaultOnboardingProvider>{children}</DefaultOnboardingProvider>;
  },
);
